module.exports = __webpack_public_path__ + "img/teacherIcon2.5b832171.jpg";